import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";
import { initialState } from "./slice";

const selectDomain = (state: RootState) => state.homeState || initialState;

export const selectHomeLoading = createSelector(
  [selectDomain],
  (homeState) => homeState.loading
);

export const selectHomeStatusItems = createSelector(
  [selectDomain],
  (homeState) => homeState.statusItems
);

export const selectHomeSummaryCards = createSelector(
  [selectDomain],
  (homeState) => homeState.summaryCards
);

export const selectHomeVehicles = createSelector(
  [selectDomain],
  (homeState) => homeState.vehicles
);

export const selectHomeScheduleExceptions = createSelector(
  [selectDomain],
  (homeState) => homeState.scheduleExceptions
);

export const selectHomeEngineeringAlerts = createSelector(
  [selectDomain],
  (homeState) => homeState.engineeringAlerts
);